import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { useAtom } from "jotai";
import { useBranding } from "../branding/useBranding";

export default function MobileFloatingLogo() {
  const branding = useBranding();

  return (
    <div className="sticky top-4 z-20 md:hidden flex w-full justify-center">
      <img className="h-12" src={`/${branding.headerImage}`} alt="Docket logo" />
    </div>
  );
}
